// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconFooterYoutubeHover: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="currentColor">
            <g fill="none" fillRule="evenodd">
                <rect width="39" height="39" x=".5" y=".5" fill="#FFF" stroke="#FFF" />
                <path
                    fill="#000"
                    fillRule="nonzero"
                    d="M28.6447689,15.877594 C28.4492545,15.1385307 27.8732023,14.556469 27.14179,14.3589373 C25.8160523,14 20.5,14 20.5,14 C20.5,14 15.183979,14 13.858211,14.3589373 C13.1267986,14.5564995 12.550746,15.1385307 12.3552316,15.877594 C12,17.2171879 12,20.012125 12,20.012125 C12,20.012125 12,22.8070621 12.3552316,24.146656 C12.550746,24.8857183 13.1267986,25.443531 13.858211,25.6410618 C15.183979,26 20.5,26 20.5,26 C20.5,26 25.816021,26 27.141789,25.6410627 C27.8732004,25.443531 28.4492545,24.8857193 28.6447689,24.146656 C29,22.8070621 29,20.012125 29,20.012125 C29,20.012125 29,17.2171879 28.6447689,15.877594 Z M18.7613523,22.5497189 L18.7613523,17.4745312 L23.2045166,20.012188 L18.7613523,22.5497189 L18.7613523,22.5497189 Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(IconFooterYoutubeHover);
